<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :show="isRoleXu"
      buttonName="导出"
      @openAddDialog="exportInfo"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      buttonType="warning"
      addShowPower="/fin/memAcctDtlExport"
      :showDownloadPower="isRoleXu"
      downloadPower="/fin/getMemAccDtlCountOperationAmt"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      @down="handleCount"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="业务类型">
        <el-select v-model="formModel.busiType" filterable>
          <el-option
            v-for="item in busiTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          v-model="formModel.orderId"
          maxlength="50"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="会员名称">
        <el-input
          v-model="formModel.realName"
          maxlength="50"
          placeholder="请输入会员名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="电话号码">
        <el-input
          v-model="formModel.phoneNumber"
          maxlength="50"
          placeholder="请输入电话号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.tranType" filterable>
          <el-option
            v-for="item in tranTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作类型">
        <el-select v-model="formModel.optType">
          <el-option
            v-for="item in optTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线路名称" prop="chnId" v-if="isRoleXu">
        <el-select v-model="formModel.chnId">
          <el-option
            v-for="item in shortNames"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变更日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="realName"
        label="会员名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="tatId"
        label="机构简称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="tranId"
        label="订单号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="电话号码"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="busiType"
        label="业务类型"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="operationType"
        label="交易类型"
        min-width="100"
        :formatter="formatTranTypee"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="operationDirection"
        label="操作类型"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p
            :class="[
              { 'text-green': scope.row.operationDirection == 1 },
              { 'text-red': scope.row.operationDirection == 2 },
            ]"
          >
            {{ scope.row.operationDirection == 1 ? "+" : "-" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="busiType"
        label="分润来源"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.fromName }} {{ scope.row.fromTel }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="chnName"
        label="线路名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
        v-if="isRoleXu"
      ></el-table-column>
      <el-table-column
        prop="operationAmt"
        label="变动金额（元）"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="balAmt"
        label="变动后余额（元）"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        min-width="160"
      ></el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="合计"
      :show="false"
      class="note"
    >
      <!--结算-->
      <div class="dialog_detail">
        <p class="tat-title">
          <span>变动金额：</span
          >{{ toDoubleThousands((dialogObj.tranAmt * 100) / 10000) }}元
        </p>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";

import FinanceService from "service/FinanceService";
import OrganService from "service/OrganService";
import StatisticsService from "service/StatisticsService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "inventeddetail",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
  },
  data() {
    return {
      shortNames: [],
      formModel: {
        tatSimpleId: "",
        orderId: "",
        tranType: "",
        optType: "",
        time: [],
        phoneNumber: "",
        busiType: "",
        realName: "",
        chnId: "",
      },
      busiTypes: [],
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      tableData: [],
      page: {},
      params: {},
      optTypes: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "收入（+）",
        },
        {
          value: "2",
          label: "支出（-）",
        },
      ],
      tranTypes: [],
      submitService: FinanceService.getMemAccDtl,
      isPage: false,
      dialogObj: {},
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    // this.getList();
    this.getTypeNames("交易类型", (res) => {
      this.tranTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.getTypeNames("业务类型", (res) => {
      this.busiTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.getShortNames("", (res) => {
      this.shortNames = [
        {
          id: "",
          shortName: "全部",
        },
        ...res,
      ];
    });
  },
  computed: {
    isRoleXu() {
      return this.roleXu.indexOf(this.userInfo.userName) > -1;
    },
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        tranType: this.formModel.tranType,
        optType: this.formModel.optType,
        busiType: this.formModel.busiType,
        startDate: this.formModel.time[0],
        endDate: this.formModel.time[1],
        orderNo: this.formModel.orderId.trim(),
        realName: this.formModel.realName.trim(),
        phoneNumber: this.formModel.phoneNumber.trim(),
        chnId: this.formModel.chnId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length == 0) {
        delete this.params.startDate;
        delete this.params.endDate;
      }

      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    formatTranTypee(row, column, cellValue) {
      let value = "";
      this.tranTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
    exportInfo() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "memAcctDtlExport",
            "",
            "/fin/"
          )
        : "";
    },
    handleCount() {
      this.doLoad(
        FinanceService.sumMemAccDtl,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.$refs.formDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getMemAccDtl,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/InventedDetail.vue